var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex justify-content-cent align-items-center" },
    [
      _vm.data
        ? _c("country-flag", {
            attrs: { country: _vm.data.iso, size: "small" },
          })
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.data.name) + "\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }